export const UPDATE_CONFIG_LIST = 'UPDATE_CONFIG_LIST'
